/* eslint-disable no-underscore-dangle */
import { Button, CircularProgress, OutlinedInput } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './style';
import { ReactComponent as M1 } from '../../../../Asset/svg/matching1.svg';
import { useHistory } from 'react-router-dom';
import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { useMemo } from 'react';

interface IMatching {
  data: any;
  linkEbook?: string;
  linkResultTest?: string;
}

const MatchingSens = (props: IMatching) => {
  const classes = useStyles();
  const history = useHistory();
  const { data, linkEbook, linkResultTest } = props;

  const percent = useMemo(() => {
    return data?.totalPercent || 0;
  }, [data]);

  const figure = useMemo(() => {
    return data?._data?.destin?.job || [];
  }, [data]);

  const figureProfil = useMemo(() => {
    return data?._data?.destin?.candidat || [];
  }, [data]);

  const valeurSens = useMemo(() => {
    return data?._data?.test?.job || [];
  }, [data]);

  const valeurSensProfil = useMemo(() => {
    return data?._data?.test?.candidat || [];
  }, [data]);

  return (
    <div className={classes.containerMatch}>
      <Grid container={true} alignItems="center" justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <M1 style={{ width: 30, height: 33, marginRight: 15 }} />
          <Typography className={classes.matchTitle}>
            Matching <span>Sens au travail</span>
          </Typography>
        </Grid>
        <Grid item={true} lg="auto">
          {data?.isComplete && (
            <CircularProgressCustom
              value={Math.round(percent)}
              color="#74B089"
              size={40}
              fontSize={12}
              fontSizeFloat={12}
              isPercent={true}
            />
          )}
        </Grid>
      </Grid>
      {/* Les figures du destin */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Les figures du destin</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkEbook && history.push(linkEbook as string)}>
            Accès ebook
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* Header */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopLeftRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}
        />
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Requis
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopRightRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Candidat
            </Typography>
          </div>
        </Grid>
        {/* Header */}

        {/* body */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Figure n°1
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: figureProfil[0] !== figure[0] ? '#E63C3C' : '' }}>
              {figure[0] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !figureProfil[0]
                ? classes.celluleKO
                : figureProfil[0] === figure[0]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!figureProfil[0] ? (
                ''
              ) : figureProfil[0] === figure[0] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {figureProfil[0] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Figure n°2
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: figureProfil[1] !== figure[1] ? '#E63C3C' : '' }}>
              {figure[1] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !figureProfil[1]
                ? classes.celluleKO
                : figureProfil[1] === figure[1]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!figureProfil[1] ? (
                ''
              ) : figureProfil[1] === figure[1] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {figureProfil[1] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomLeftRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Figure n°3
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderRight: '1px solid #5E65A3', borderBottom: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: figureProfil[2] !== figure[2] ? '#E63C3C' : '' }}>
              {figure[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomRightRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div
            className={
              !figureProfil[2]
                ? classes.celluleKO
                : figureProfil[2] === figure[2]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!figureProfil[2] ? (
                ''
              ) : figureProfil[2] === figure[2] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {figureProfil[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* Les figures du destin */}

      <div className={classes.separator} />

      {/* Test des 10 valeurs de Sens® */}
      <Grid
        style={{ marginTop: 20 }}
        container={true}
        alignItems="center"
        justifyContent="space-between">
        <Grid item={true} lg="auto" style={{ display: 'flex', alignItems: 'center' }}>
          <Typography className={classes.titleTable}>Test des 10 valeurs de Sens®</Typography>
        </Grid>
        <Grid item={true} lg="auto">
          <Button
            disabled={linkResultTest === ''}
            variant="contained"
            color="primary"
            className={classes.btnPrimarySeek}
            onClick={() => linkResultTest && history.push(linkResultTest)}>
            Accès résultats
          </Button>
        </Grid>
      </Grid>
      <Grid style={{ marginTop: 20 }} container={true} item={true}>
        {/* Header */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopLeftRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderLeft: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}
        />
        <Grid
          item={true}
          lg={4}
          style={{
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Requis
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderTopRightRadius: 5,
            borderTop: '1px dashed #5E65A3',
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px dashed #5E65A3',
          }}>
          <div className={classes.cellule} style={{ padding: 20 }}>
            <Typography variant="h6" className={classes.celluleHeader}>
              Candidat
            </Typography>
          </div>
        </Grid>
        {/* Header */}

        {/* body */}
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Valeur n°1
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: valeurSensProfil[0] !== valeurSens[0] ? '#E63C3C' : '' }}>
              {valeurSens[0] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !valeurSensProfil[0]
                ? classes.celluleKO
                : valeurSensProfil[0] === valeurSens[0]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!valeurSensProfil[0] ? (
                ''
              ) : valeurSensProfil[0] === valeurSens[0] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {valeurSensProfil[0] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Valeur n°2
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: valeurSensProfil[1] !== valeurSens[1] ? '#E63C3C' : '' }}>
              {valeurSens[1] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderBottom: '1px solid #5E65A3', borderRight: '1px solid #5E65A3' }}>
          <div
            className={
              !valeurSensProfil[1]
                ? classes.celluleKO
                : valeurSensProfil[1] === valeurSens[1]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!valeurSensProfil[1] ? (
                ''
              ) : valeurSensProfil[1] === valeurSens[1] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {valeurSensProfil[1] || 'NC'}
            </Typography>
          </div>
        </Grid>

        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomLeftRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderLeft: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div className={classes.cellule}>
            <Typography variant="h6" className={classes.celluleFigure}>
              Valeur n°3
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{ borderRight: '1px solid #5E65A3', borderBottom: '1px solid #5E65A3' }}>
          <div className={classes.cellule}>
            <Typography
              variant="h6"
              className={classes.celluleMatch}
              style={{ color: figureProfil[2] !== figure[2] ? '#E63C3C' : '' }}>
              {valeurSens[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
        <Grid
          item={true}
          lg={4}
          style={{
            borderBottomRightRadius: 5,
            borderBottom: '1px solid #5E65A3',
            borderRight: '1px solid #5E65A3',
          }}>
          <div
            className={
              !valeurSensProfil[2]
                ? classes.celluleKO
                : valeurSensProfil[2] === valeurSens[2]
                ? classes.celluleOK
                : classes.celluleKO
            }>
            <Typography variant="h6" className={classes.celluleMatch}>
              {!valeurSensProfil[2] ? (
                ''
              ) : valeurSensProfil[2] === valeurSens[2] ? (
                <CheckIcon />
              ) : (
                <CloseIcon />
              )}
              {valeurSensProfil[2] || 'NC'}
            </Typography>
          </div>
        </Grid>
      </Grid>
      {/* Test des 10 valeurs de Sens® */}
    </div>
  );
};

export default MatchingSens;
